/**
  * @class meleText
  * @description
  *
  * # Purpose
  * Implements `<mele-text>` custom web element.
  * Displays plain text that will be automatically translated.
  *
  * # Use
  * Create element in HTML:
  * ```
  * <mele-text label="{{day}} #3: {{WeekDay3}}"></mele-text>
  * ```
  * Create element in JavaScript:
  * ```
  * parentEl.appendChildren({
  *   tag: 'mele-text',
  *   label: '{{day}} #3: {{WeekDay3}}',
  * })
  * ```
  *
  * # Implementation notes
  *
  */

import meleElement from 'meleElement'

const PROPERTIES = _.extend({}, {
  label: { description: 'content of the text, will be localized', type: 'string' },
  color: { description: 'color of the text', type: 'string' },
}, meleElement._properties)

export default class meleText extends meleElement {
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  /**
  * Handle change of attribute "label"
  */
  labelChanged(value) {
    const html = this.translateAndSetDependencies(value, false, 'label')
    if(this.innerHTML != html) this.innerHTML = html
  } // labelChanged

  colorChanged(value) {
    this.style.color = value
  }

  simplify() {
    const repl = this.ownerDocument.createElement('div')
    const cls = this.class.split(' ').filter(i=>!/mele-/.test(i))
    if(this.hidden) {
      cls.push('hidden')
    } else {
      cls.push('mele-text')
    }
    repl.className = cls.join(' ')
    repl.innerHTML = this.innerHTML
    this.parentNode.replaceChild(repl, this)
    return repl
  }
} // class meleText

meleText._properties = PROPERTIES
meleText.observedAttributes = _.keys(PROPERTIES)

window.customElements.define('mele-text', meleText)
